import {CodeDescriptionRestDto} from "@/api/pharma-cms-content-block/models";

export class CodeDescriptionRestDtoModel implements CodeDescriptionRestDto {
    code: string;
    description: string;

    constructor(code: string, description: string) {
        this.code = code;
        this.description = description;
    }

    public static createWithDefaults(): CodeDescriptionRestDtoModel {
        return new CodeDescriptionRestDtoModel('code', 'description');
    }
}
